import React, { useContext, useState } from 'react';
import { Box } from '@mui/material';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import {
  useDeleteTemplateMutation,
  useTemplatesQuery,
  ITemplate,
  TemplatesDocument,
  ITemplatesQuery
} from '../../generated/graphql';
import OverviewTable from '../Common/Tables/OverviewTable';
import TemplateEditor from './TemplateEditor';

const Templates: React.FunctionComponent = () => {
  const { dispatch } = useContext(AppContext);
  const [deleteTemplate] = useDeleteTemplateMutation();
  const { data, loading } = useTemplatesQuery();
  const [openTemplateEditor, setOpenTemplateEditor] = useState(false);
  const [selectedTempalte, setSelectedTempalte] = useState<ITemplate | null>(null);

  const handleDelete = (rowData: ITemplate) => {
    if (!rowData.id) {
      return;
    }
    dispatch({ type: Actions.HideConfirmation });
    deleteTemplate({
      variables: {
        id: parseInt(rowData.id)
      },
      update(cache) {
        const templateQuery = cache.readQuery({
          query: TemplatesDocument
        }) as ITemplatesQuery;
        if (templateQuery.result) {
          const cacheTemplateIndex = templateQuery.result.findIndex((c) => c?.id === rowData.id);
          if (cacheTemplateIndex > -1) {
            const data = templateQuery.result.filter(function (el) {
              return el?.id !== rowData.id;
            });
            cache.writeQuery({
              query: TemplatesDocument,
              data: { result: data }
            });
          }
        }
        dispatch({
          type: Actions.ShowMessage,
          payload: { text: `Template ${rowData.title} deleted`, severity: 'success' }
        });
      }
    }).catch((error) =>
      dispatch({
        type: Actions.ShowMessage,
        payload: {
          severity: 'error',
          text: error.message,
          autoHide: 6000
        }
      })
    );
  };

  const remove = (rowData: ITemplate) => {
    dispatch({
      type: Actions.ShowConfirmation,
      payload: {
        text: `Are you sure you want to delete ${rowData.title}?`,
        agreeAction: handleDelete,
        params: rowData
      }
    });
  };

  const handleDetailsPressed = (rowData: ITemplate) => {
    setSelectedTempalte(rowData);
    setOpenTemplateEditor(true);
  };

  const handleCloseEditor = () => {
    setSelectedTempalte(null);
    setOpenTemplateEditor(false);
  };

  const columns = [
    {
      title: 'Details',
      width: 62.5,
      sorting: false
      // render: renderRecipientsColumn
    },
    {
      title: 'Name',
      field: 'title',
      width: 499
    },
    {
      title: 'Email Subject',
      field: 'subject',
      width: 1088
    },
    {
      title: 'Remove',
      width: 71.5,
      sorting: false
    }
  ];

  return (
    <Box className="overviewPage">
      <Box className="print\:w-full">
        <OverviewTable
          columns={columns}
          data={data?.result || []}
          loading={loading}
          handleDetails={handleDetailsPressed}
          handleRemove={remove}
          pageSize={15}
          createButtonProps={{
            id: 'create-template-button',
            onClick: () => setOpenTemplateEditor(true),
            text: 'Create Template',
            disabled: false
          }}
        />
        {openTemplateEditor && (
          <TemplateEditor handleClose={handleCloseEditor} template={selectedTempalte} />
        )}
      </Box>
    </Box>
  );
};

export default Templates;
